/**
 * Layout header component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Logo from '../../../components/logo/logo';

// Javascript

import DrawerJs from '../../../assets/js/drawer';

export default class Header extends PureComponent {

	constructor(props) {

		super(props);
		
    	this.handleClick = this.handleClick.bind(this);
	}

	handleClick(event) {
				
		event.preventDefault();

		const target = event.currentTarget;
		const controls = target.getAttribute('aria-controls');
		const panel = document.getElementById(controls);

		DrawerJs.transition(panel, 'open');
	}

	render() {
		
		const { children, settings } = this.props;

		if (settings) {

			const { company_header_logo } = settings;

			return (
				
		        <header className="layout-header">

		        	<div className="head container">

		        		<Logo data={company_header_logo}></Logo>
						<button type="button" className="button button-drawer" data-toggle="#layout-drawer" aria-controls="layout-drawer" onClick={this.handleClick}><span><span>Show navigation</span></span></button>

						{children}

					</div>
					
				</header>
			);
		}
		else {

			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/header/header.js